import { Section } from 'components/Section';
import { Ad } from 'components/Ad';
import { AdBlock } from 'models/AdBlock';
import { NO_ELEMENT } from 'utils';
import connect from 'components/Shared/connect';
import { isMobile, isMobileLayout } from 'components/Shared/responsive';
import { Appearances } from 'models/SectionBlock';
import { Campaigns } from './campaigns';

interface OwnProps extends AdBlock {
  full?: boolean;
}
interface MergedProps extends OwnProps {
  isMobileLayout: boolean;
  isMobile: boolean;
}
export const Ads = connect<MergedProps, OwnProps>(state => ({
  isMobileLayout: isMobileLayout(state),
  isMobile: isMobile(state)
}))(({ ad, ads, isMobile, ...props }: MergedProps) => {
  let content;
  if (ad) {
    content = <Ad ad={ad} />;
  } else if (ads) {
    content = <Campaigns ads={ads} />;
  } else {
    return NO_ELEMENT;
  }

  const hasTitle = !!props.title;

  return (
    <Section {...props} isClear={!hasTitle} appearance={Appearances.Tertiary} isDesktop={!isMobile}>
      {content}
    </Section>
  );
});
